import React from "react";
import moment from "moment";
import { QrcodeImgService_BASE_URL } from "../utils/constants/api.constants";
const ItemRow = ({
  addedItems,
  handleRemoveItem,
  handleInputChange,
  handleGetirndetail,
  grandTotal,
  state,
  handleItemChange,
  isPurchase,
  isDiscount,
  isSale,
  isViewMode,
  roundedGrandTotal,
}) => {
  console.log("state", state);

  const getCostBeforeTax = (item) => {
    const price = parseFloat(item?.price) || 0;
    const quantity = parseFloat(item?.quantity) || 0;
    const taxRate = parseFloat(item?.tax) || 0;
    const total = price * quantity;

    if (item?.price_tax_type === "Including Tax" && taxRate > 0) {
      const taxPortion = (total * taxRate) / (100 + taxRate);
      return (total - taxPortion).toFixed(2);
    }

    return total.toFixed(2);
  };

  // compute calculated roundoff same as invoice formula
  const calcRoundoff = (() => {
    const raw = Number(grandTotal) || 0;
    const rounded = Number(roundedGrandTotal) || Math.round(raw);
    const r = +(rounded - raw).toFixed(2);
    return r;
  })();

  return (
    <>
      {addedItems?.map((item, index) => (
        <tr key={index}>
          <td
            className="align-middle"
            style={{ fontWeight: "300", fontSize: "14px", textAlign: "" }}
          >
            {state?.itemList?.find((unit) => unit.id == item?.item_id)?.name ||
              "N/A"}
          </td>
          <td className="align-middle">{item?.hsn}</td>
          <td className="align-middle">
            <input
              className="form-control"
              type="text"
              value={item?.quantity}
              onChange={(e) =>
                handleItemChange("quantity", e.target.value, index)
              }
            />
          </td>
          <td className="align-middle">
            {state?.units?.find((unit) => unit.id == item?.unit_id)?.unit ||
              "N/A"}
          </td>
          <td className="align-middle">
            <input
              type="text"
              className="form-control"
              name="price"
              value={item?.price !== undefined ? item.price : ""} // Allow empty input
              onChange={(e) => {
                let inputValue = e.target.value;

                // Check for valid input: allow numbers with up to 2 decimal places, or allow an empty value
                const validInput = /^(0|[1-9]\d*)(\.\d{0,2})?$/.test(
                  inputValue
                );

                // If input is valid or empty, update the state
                if (validInput || inputValue === "") {
                  handleItemChange("price", inputValue, index);
                }
              }}
              onBlur={() => {
                // On blur, if input is empty, reset it to 0.00
                if (item.price === "" || item.price === undefined) {
                  handleItemChange("price", "0.00", index);
                }
              }}
            />
          </td>
          <td className="align-middle">₹{getCostBeforeTax(item)}</td>
          {isDiscount && (
            <td className="align-middle">
              <div className="d-flex flex-column" style={{ gap: "5px" }}>
                <input
                  type="text"
                  className="form-control"
                  name="discount"
                  value={item?.discount !== undefined ? item.discount : ""} // Allow empty input
                  onChange={(e) => {
                    let inputValue = e.target.value;

                    // Check for valid input: allow numbers with up to 2 decimal places, or allow an empty value
                    const validInput = /^(0|[1-9]\d*)(\.\d{0,2})?$/.test(
                      inputValue
                    );

                    if (validInput || inputValue === "") {
                      const maxDiscount =
                        item?.discount_type === "Fixed"
                          ? (
                              Number(item?.price) * Number(item?.quantity)
                            ).toFixed(2)
                          : 100; // 100% for percentage discount

                      // Enforce max discount rules
                      if (
                        item?.discount_type === "Fixed" &&
                        parseFloat(inputValue) > parseFloat(maxDiscount)
                      ) {
                        inputValue = maxDiscount;
                      } else if (
                        item?.discount_type === "Percentage" &&
                        parseFloat(inputValue) > maxDiscount
                      ) {
                        inputValue = maxDiscount;
                      }

                      handleItemChange("discount", inputValue, index);
                    }
                  }}
                  onBlur={() => {
                    // On blur, if input is empty, reset it to 0.00
                    if (item.discount === "" || item.discount === undefined) {
                      handleItemChange("discount", "0.00", index);
                    }
                  }}
                />
                <select
                  className="form-control"
                  name="discount_type"
                  value={
                    item?.discount_type
                      ? item.discount_type.charAt(0).toUpperCase() +
                        item.discount_type.slice(1)
                      : ""
                  }
                  onChange={(e) =>
                    handleItemChange("discount_type", e.target.value, index)
                  }
                >
                  <option value="Fixed">Fixed</option>
                  <option value="Percentage">Percentage</option>
                </select>
              </div>
            </td>
          )}

          <td className="align-middle">
            <div className="d-flex flex-column " style={{ gap: "5px" }}>
              <select
                className="form-control"
                name="tax"
                value={parseFloat(item?.tax)}
                onChange={(e) => handleItemChange("tax", e.target.value, index)}
              >
                <option value="0">Exempted</option>
                <option value="2.5">2.5%</option>
                <option value="5">5%</option>
                <option value="12">12%</option>
                <option value="18">18%</option>
                <option value="28">28%</option>
              </select>
              <select
                className="form-control"
                name="price_tax_type"
                value={item?.price_tax_type}
                onChange={(e) =>
                  handleItemChange("price_tax_type", e.target.value, index)
                }
                style={{ padding: "0.4rem" }}
              >
                <option value="Including Tax">Including Tax</option>
                <option value="Excluding Tax">Excluding Tax</option>
              </select>
            </div>
          </td>
{/* 
          {isPurchase && (
            <td class="align-middle">
              <div class="input-group">
                <select
                  class="form-control"
                  name="add_tax"
                  value={item?.add_tax}
                  onChange={(e) =>
                    handleItemChange("add_tax", e.target.value || "", index)
                  }
                >
                  <option value="0">None</option>
                  {state?.additionaltax &&
                    state?.additionaltax?.map((tax, index) => (
                      <option
                        key={index}
                        value={`${Number(tax?.tax_perc)?.toFixed(0)}@${
                          tax?.tax_type
                        }`}
                      >
                        {`${Number(tax?.tax_perc)?.toFixed(0)}@${
                          tax?.tax_type
                        }`}
                      </option>
                    ))}
                </select>
              </div>
            </td>
          )} */}
          <td className="align-middle">
            ₹{Number(item.total_amount || 0).toFixed(2)}
          </td>
          <td>
            <button
              className="btn-sm btn-danger"
              onClick={() => handleRemoveItem(index)}
            >
              Remove
            </button>
          </td>
        </tr>
      ))}

      <tr>
        {/* Show Barcode only if not in view mode */}
        {isViewMode && (
          <td colSpan="4" rowSpan="6" className="align-top">
            <div className="p-2">
              {/* Flex container to arrange QR code and details side by side */}
              <div style={{ display: "flex", gap: "1rem", alignItems: "flex-start", flexWrap: "wrap" }}>
                {/* QR Code Image - left side */}
                <div className="">
                  <img
                    src={`${QrcodeImgService_BASE_URL}/irn-qr/${state.qrcode_file}`}
                    alt="QR Code"
                    style={{
                      width: "150px",
                      height: "150px",
                      objectFit: "contain",
                    }}
                  />
                </div>

                {/* Invoice Details - right side */}
                <div className="flex flex-col justify-center text-left space-y-2 ml-2">
                  <div>
                    <strong>IRN Number:</strong> {state.irn_number}
                  </div>
                  <div>
                    <strong>Acknowledge Number:</strong>{" "}
                    {state.acknowledge_number}
                  </div>
                  <div>
                    <strong>Acknowledge Date:</strong>{" "}
                    {moment(state.acknowledge_date).format("DD-MM-YYYY")}
                  </div>
                </div>
              </div>

              {/* Generate Button - bottom */}
              <div className="mt-4 text-center">
                <button
                  type="button"
                  className="btn btn-default"
                  onClick={handleGetirndetail}
                >
                  Generate E-invoice
                </button>
              </div>
            </div>
          </td>
        )}

        {isSale && (
          <>
            <td
              colSpan={isViewMode && state.qrcode_file ? 4 : 8}
              className="text-right align-middle"
            >
              <strong>Taxable Amount:</strong>
            </td>
            <td colSpan="3" className="align-middle">
              ₹{" "}
              {state?.addedItems
                ?.reduce((sum, item) => sum + Number(item.sub_total), 0)
                .toFixed(2)}
            </td>
          </>
        )}
      </tr>

      {/* Shipment row: only show for invoice add/edit (isSale) or purchase voucher (isPurchase) */}
      {(isSale || isPurchase) && (
        <tr>
          <td
            colSpan={isViewMode && state.qrcode_file ? 4 : 8}
            className="text-right align-middle"
            style={{ whiteSpace: "nowrap", paddingRight: "1rem" }}
          >
            <strong>Shipment Amount:</strong>
          </td>

          <td className="align-middle" style={{ width: "120px" }}>
            <input
              type="number"
              className="form-control form-control-sm"
              value={state?.shippingCost || ""}
              onChange={(e) => handleInputChange("shippingCost", e.target.value)}
              style={{ minWidth: "100px" }}
            />
          </td>
          <div className="d-flex flex-column">
            <td className="align-middle" style={{ width: "120px" }}>
              <select
                className="form-control form-control-sm"
                name="tax"
                value={state?.shipping_tax_percent ?? state?.shippingTaxPercent ?? ""}
                onChange={(e) => handleInputChange("shipping_tax_percent", e.target.value)}
                style={{ minWidth: "100px" }}
              >
                <option value="0">Exempted</option>
                <option value="2.5">2.5%</option>
                <option value="5">5%</option>
                <option value="12">12%</option>
                <option value="18">18%</option>
                <option value="28">28%</option>
              </select>
            </td>

            <td className="align-middle" style={{ width: "120px" }}>
              <select
                className="form-control form-control-sm"
                name="shipping_tax_type"
                value={state?.shipping_tax_type ?? state?.shippingTaxType ?? ""}
                onChange={(e) => handleInputChange("shipping_tax_type", e.target.value)}
                style={{ minWidth: "100px" }}
              >
                <option value="including">Including</option>
                <option value="excluding">Excluding</option>
              </select>
            </td>
          </div>
        </tr>
      )}

      {Object.entries(state?.taxAmounts)?.map(([taxRate, amount], index) =>
        Number(amount) > 0 ? (
          <tr key={index}>
            <td
              colSpan={isViewMode && state.qrcode_file ? 4 : 8}
              className="text-right align-middle"
            >
              <strong>GST {Number(taxRate)?.toFixed(1)}%:</strong>
            </td>
            <td colSpan="3" className="align-middle">
              ₹ {amount.toFixed(2)}
            </td>
          </tr>
        ) : null
      )}

      {isPurchase && (
        <tr>
          <td
            colSpan={isViewMode && state.qrcode_file ? 4 : 8}
            className="text-right align-middle"
          >
            <strong>Round off</strong>
          </td>
          <td colSpan="4" className="align-middle">
            {/* Editable input for purchases only */}
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              <input
                type="number"
                step="0.01"
                className="form-control"
                style={{ maxWidth: '140px' }}
                value={(state?.roundoffEdited ? Number(state.roundoff) : calcRoundoff).toFixed(2)}
                onChange={(e) => handleInputChange && handleInputChange('roundoff', e.target.value)}
              />
              {/* <small className="text-muted">Calculated: {(calcRoundoff).toFixed(2)}</small> */}
            </div>
          </td>
        </tr>
      )}

      {isSale && (
        <tr>
          <td
            colSpan={isViewMode && state.qrcode_file ? 4 : 8}
            className="text-right align-middle"
          >
            <strong>Round off</strong>
          </td>
          <td colSpan="3" className="align-middle">
            ₹ {Number(state?.roundoff).toFixed(2) || '0.00'}
            {/* ₹ {state?.roundoff !== undefined ? Number(state.roundoff).toFixed(2) : (roundedGrandTotal !== undefined ? Number((Number(roundedGrandTotal) - Number(grandTotal)).toFixed(2)).toFixed(2) : "0.00")} */}
          </td>
        </tr>
      )}

      <tr>
        <td
          colSpan={isViewMode && state.qrcode_file ? 4 : 8}
          className="text-right align-middle"
        >
          <strong>Grand Total:</strong>
        </td>
        <td colSpan="4" className="align-middle">
          ₹ {(() => {
            if (isSale) return Number(state.roundedGrandTotal).toFixed(2);
            const roundToUse = state?.roundoffEdited ? Number(state.roundoff || 0) : calcRoundoff;
            return (Number(grandTotal || 0) + Number(roundToUse)).toFixed(2);
          })()}
        </td>
      </tr>
    </>
  );
};

export default ItemRow;
